<template>
  <v-row>
    <v-col cols="12" v-if="loadingInitial">
      <v-boilerplate type="card-heading, image, actions" />
    </v-col>
    <v-col cols="12" v-else>
      <v-card>
        <v-card-text class="py-4 background">
          <v-row justify="space-between">
            <!-- customer -->
            <v-col cols="12" class="text-center py-5" v-if="!order.customer">
              <v-icon class="d-block" color="secondary" size="70">mdi-account</v-icon>
              <span class="d-block subtitle-1">Selecciona un cliente para continuar</span>
              <v-btn class="my-5" @click="dialogCustomer=true" outlined color="secondary">Seleccionar un cliente</v-btn>
            </v-col>
            <v-col cols="6" v-else>
              <v-toolbar color="transparent" flat height="48">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Cliente</v-toolbar-title>
              </v-toolbar>
              <v-divider />
              <v-list class="transparent" two-line>
                <v-list-item>
                  <v-menu open-on-hover bottom offset-y :nudge-bottom="15" :close-delay="100" transition="slide-y-transition">
                    <template v-slot:activator="{on}">
                      <v-list-item-content v-on="on">
                        <v-list-item-title class="subtitle-2 text--secondary font-weight-medium">{{activeCustomer.name}}</v-list-item-title>
                        <v-list-item-subtitle class="text--primary">{{activeCurrency.id}} - {{activeCurrency.name}}</v-list-item-subtitle>
                      </v-list-item-content>
                    </template>
                    <v-card>
                      <v-card-text>
                        <v-list class="v-list-form transparent">
                          <v-list-item class="px-0">
                            <v-list-item-title>ID Fiscal</v-list-item-title>
                            <v-list-item-subtitle v-if="activeCustomer.tax_id">{{activeCustomer.tax_id}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text--disabled font-italic" v-else>Sin ID Fiscal</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Dirección</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.address}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Estado</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.state.name}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>País</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.country.name}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Email</v-list-item-title>
                            <v-list-item-subtitle>{{activeCustomer.email}}</v-list-item-subtitle>
                          </v-list-item>
                          <v-list-item class="px-0">
                            <v-list-item-title>Teléfono</v-list-item-title>
                            <v-list-item-subtitle v-if="activeCustomer.phone">{{activeCustomer.phone}}</v-list-item-subtitle>
                            <v-list-item-subtitle class="text--disabled font-italic" v-else>Sin teléfono</v-list-item-subtitle>
                          </v-list-item>
                        </v-list>
                      </v-card-text>
                    </v-card>
                  </v-menu>
                  <v-list-item-action>
                    <v-btn @click="dialogCustomer=true" outlined color="secondary">Cambiar...</v-btn>
                  </v-list-item-action>
                </v-list-item>
              </v-list>
              <v-divider />
            </v-col>
            <!-- end customer -->

            <v-col cols="6" v-if="order.customer">
              <v-list class="v-list-form transparent">
                <v-list-item class="py-1">
                  <v-list-item-title class="text-right text--secondary font-weight-medium">Tipo de factura</v-list-item-title>
                  <v-list-item-subtitle class="ml-4">
                    <v-select v-model="$v.order.document.$model" :error="$v.order.document.$error" :items="selectDocuments" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details>
                      <template v-slot:item="data">
                        <v-list-item-title class="font-weight-regular">{{data.item.name}}</v-list-item-title>
                      </template>
                    </v-select>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item class="py-1">
                  <v-list-item-title class="text-right text--secondary font-weight-medium">Fecha</v-list-item-title>
                  <v-list-item-subtitle class="ml-4">
                    <v-menu v-model="datePickerMenuOrderDate" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field v-model="$v.order.date.$model" :error="$v.order.date.$error" v-bind="attrs" v-on="on" background-color="white" outlined single-line dense readonly hide-details>
                          <template v-slot:append>
                            <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                          </template>
                        </v-text-field>
                      </template>
                      <v-date-picker v-model="$v.order.date.$model" @input="datePickerMenuOrderDate=false" min="2020-01-01" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="primary">
                        <v-row class="py-2 px-6" align="center" justify="end">
                          <v-btn @click="() => { $v.order.date.$model=today; datePickerMenuOrderDate=false }" color="primary">Hoy</v-btn>
                        </v-row>
                      </v-date-picker>
                    </v-menu>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>

          <!-- shipping detail  -->
          <v-toolbar color="transparent" flat height="55">
            <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información del despacho</v-toolbar-title>
          </v-toolbar>
          <v-divider />
          <v-list class="v-list-form transparent py-6">
            <v-row>
              <v-col cols="6">
                <v-list-item>
                  <v-list-item-title>Tipo de envío</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="8" class="px-0 py-1">
                      <v-select v-model="$v.order.shipping_type.$model" :error="$v.order.shipping_type.$error" :items="shippingTypes" item-text="label" item-value="value" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Dirección de envío</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="12" class="px-0 py-1">
                      <v-text-field outlined single-line maxlength="70" :error="$v.order.address.$error" dense v-model="$v.order.address.$model" hide-details background-color="white" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>País</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="8" class="px-0 py-1">
                      <v-select v-model="order.country" :items="countriesList" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Estado</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="8" class="px-0 py-1">
                      <v-select v-model="order.state" :items="statesList" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" height="30" background-color="white" single-line outlined dense hide-details no-data-text="No existen estados para el país." />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-col>
              <v-col cols="6">
                <v-list-item>
                  <v-list-item-title>Nombre del conductor</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="12" class="px-0 py-1">
                      <v-text-field v-model="$v.order.carrier_name.$model" :error="$v.order.carrier_name.$error" outlined single-line dense maxlength="30" hide-details background-color="white" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>ID del conductor</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="7" class="px-0 py-1">
                      <v-text-field v-model="$v.order.carrier_id.$model" :error="$v.order.carrier_id.$error" outlined single-line dense maxlength="10" hide-details background-color="white" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Patente del transporte</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="7" class="px-0 py-1">
                      <v-text-field outlined single-line :error="$v.order.licence_plate.$error" class="pa-0" dense v-model="$v.order.licence_plate.$model" maxlength="7" hide-details background-color="white" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
                <v-list-item>
                  <v-list-item-title>Comentario adicional</v-list-item-title>
                  <v-list-item-subtitle>
                    <v-col cols="12" class="px-0 py-1">
                      <v-text-field v-model="$v.order.note.$model" :error="$v.order.note.$error" outlined single-line dense maxlength="100" hide-details background-color="white" />
                    </v-col>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-col>
            </v-row>
          </v-list>
          <!-- end shipping detail  -->

          <!-- lines -->
          <v-row class="mt-8" justify="space-between">
            <v-col cols="12">
              <v-toolbar color="transparent" flat height="20">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Productos</v-toolbar-title>
              </v-toolbar>
            </v-col>
          </v-row>

          <v-divider />

          <v-row class="px-5" justify="space-between">
            <v-col cols="4" class="pl-2">
              <span class="text--secondary body-2 font-weight-medium">Producto</span>
            </v-col>
            <v-col cols="1" class="px-0">
              <span class="text--secondary body-2 font-weight-medium">Cantidad</span>
            </v-col>
            <v-col cols="1" class="px-0">
              <span class="text--secondary body-2 font-weight-medium">Unidad</span>
            </v-col>
            <v-col class="px-0 text-right" style="max-width: 110px">
              <span class="text--secondary body-2 font-weight-medium">Precio</span>
            </v-col>
            <v-col class="px-0 text-center" style="max-width: 50px">
              <span class="text--secondary body-2 font-weight-medium">Exento</span>
            </v-col>
            <v-col class="px-0 text-right" style="max-width: 110px">
              <span class="text--secondary body-2 font-weight-medium">Subtotal</span>
            </v-col>
            <v-col class="px-0 text-right" style="max-width: 30px"></v-col>
          </v-row>

          <v-divider />

          <template v-for="(d, i) in order.lines">
            <v-row class="v-sm-text-fields px-5" align="start" justify="space-between" :key="`line-${i}`">
              <v-col cols="4" class="pl-1">
                <v-text-field v-model.trim="$v.order.lines.$each[i].name.$model" :error="$v.order.lines.$each[i].name.$error" required maxlength="80" placeholder="Escribe un nombre..." background-color="white" height="16" outlined flat dense hide-details />
                <v-text-field v-model.trim="$v.order.lines.$each[i].description.$model" :error="$v.order.lines.$each[i].description.$error" required maxlength="512" placeholder="Escribe una descripción..." background-color="white" height="16" outlined flat dense hide-details />
              </v-col>
              <v-col cols="1" class="px-0">
                <v-text-field v-model.number="$v.order.lines.$each[i].quantity.$model" :error="$v.order.lines.$each[i].quantity.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" required maxlength="12" placeholder="0" background-color="white" height="16" outlined flat dense hide-details />
              </v-col>
              <v-col cols="1" class="px-0">
                <v-text-field v-model.trim="d.unit_label" :error="$v.order.lines.$each[i].unit_label.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" maxlength="4" placeholder="C/U" background-color="white" height="16" outlined flat dense hide-details />
              </v-col>
              <v-col class="px-0 text-right" style="max-width: 110px">
                <v-text-field v-model.number="$v.order.lines.$each[i].amount.$model" :error="$v.order.lines.$each[i].amount.$error" oninput="this.value=this.value.replace(/[^0-9.]/g,'');" required maxlength="12" placeholder="0" single-line background-color="white" height="16" reverse outlined flat dense hide-details />
              </v-col>
              <v-col class="px-0 text-center" style="max-width: 50px">
                <v-switch class="mt-0 mr-n2 d-inline-block" v-model="d.exempt" :disabled="!activeDocument.has_taxes" dense hide-details />
              </v-col>
              <v-col class="px-0 text-right" style="max-width: 110px">
                <span class="d-block mt-0 mb-9 text--secondary body-2 font-weight-medium">
                  <template v-if="$v.order.lines.$each[i].amount.$error || $v.order.lines.$each[i].quantity.$error">-</template>
                  <template v-else>{{aggregations.lines[i].subtotal | currency(activeCurrency.id)}} {{activeCurrency.id}}</template>
                </span>
              </v-col>
              <v-col class="px-0 text-right" style="max-width: 30px">
                <v-btn class="mt-0 mb-9" @click="order.lines.splice(i, 1)" :disabled="order.lines.length === 1" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
              </v-col>
            </v-row>
            <v-divider :key="`divider-${i}`" />
          </template>

          <v-row class="px-4" no-gutters>
            <v-col class="text-left">
              <v-btn @click="addOrderLine" text color="primary" :ripple="false"><v-icon left>mdi-plus</v-icon>Agregar un producto</v-btn>
            </v-col>
          </v-row>
          <!-- end lines -->

          <!-- summary -->
          <v-row align="center" justify="end">
            <v-col cols="5">
              <v-list class="v-list-form pa-0 transparent">
                <v-list-item class="py-0">
                  <v-list-item-title>Subtotal</v-list-item-title>
                  <v-list-item-subtitle class="text-right font-weight-medium">
                    <template v-if="linesWithAmountsError.length">-</template>
                    <template v-else>{{aggregations.subtotal | currency(activeCurrency.id)}}</template>
                  </v-list-item-subtitle>
                </v-list-item>
                <template v-if="activeDocument.has_taxes_detail">
                  <v-divider class="ml-4 my-1" />
                  <v-list-item class="py-0">
                    <v-list-item-title>Exento</v-list-item-title>
                    <v-list-item-subtitle class="text-right font-weight-medium">
                      <template v-if="linesWithAmountsError.length">-</template>
                      <template v-else>{{aggregations.exempt | currency(activeCurrency.id)}}</template>
                    </v-list-item-subtitle>
                  </v-list-item>
                  <template v-if="activeDocument.has_taxes">
                    <v-list-item class="py-0">
                      <v-list-item-title>Neto</v-list-item-title>
                      <v-list-item-subtitle class="text-right font-weight-medium">
                        <template v-if="linesWithAmountsError.length">-</template>
                        <template v-else>{{aggregations.amount | currency(activeCurrency.id)}}</template>
                      </v-list-item-subtitle>
                    </v-list-item>
                    <v-divider class="ml-4 my-1" />
                    <v-list-item>
                      <v-list-item-title>Impuestos ({{activeDocument.tax}}%)</v-list-item-title>
                      <v-list-item-subtitle class="text-right font-weight-medium">
                        <template v-if="linesWithAmountsError.length">-</template>
                        <template v-else>{{aggregations.taxes | currency(activeCurrency.id)}}</template>
                      </v-list-item-subtitle>
                    </v-list-item>
                  </template>
                </template>
                <v-divider class="ml-4 my-1" />
                <v-list-item class="py-0">
                  <v-list-item-title class="body-1 text--secondary font-weight-medium">Total</v-list-item-title>
                  <v-list-item-subtitle class="text-right body-1 font-weight-medium">
                    <template v-if="linesWithAmountsError.length">-</template>
                    <template v-else>{{aggregations.total | currency(activeCurrency.id)}} {{activeCurrency.id}}</template>
                  </v-list-item-subtitle>
                </v-list-item>
              </v-list>
            </v-col>
          </v-row>
          <!-- end summary -->

          <!-- additional information -->
          <v-row align="center" justify="space-between">
            <v-col cols="12">
              <v-toolbar color="transparent" flat height="20">
                <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Información adicional<v-chip class="ml-3 mt-n1" color="secondary" x-small>Opcional</v-chip></v-toolbar-title>
              </v-toolbar>
            </v-col>
          </v-row>
          <v-divider />
          <v-row class="v-sm-text-fields" align="center" justify="space-between">
            <v-col cols="12">
              <v-list class="v-list-form-extended transparent">
                <v-list-item>
                  <v-list-item-title class="pt-2 text--secondary font-weight-medium">Referencias</v-list-item-title>
                </v-list-item>
              </v-list>
            </v-col>
            <v-col cols="12" class="px-6 py-0">
              <v-row no-gutters v-if="order.references.length" >
                <v-col class="py-0 ml-1" cols="2">
                  <span class="body-2 text--secondary">Fecha</span>
                </v-col>
                <v-col class="py-0" cols="3">
                  <span class="body-2 text--secondary">Documento</span>
                </v-col>
                <v-col class="py-0" cols="2">
                  <span class="body-2 text--secondary">Identificador</span>
                </v-col>
                <v-col class="py-0" cols="4">
                  <span class="body-2 text--secondary">Descripción</span>
                </v-col>
              </v-row>
              <v-row v-for="(d, i) in order.references" :key="i" no-gutters>
                <v-col cols="2" class="py-0">
                  <v-menu v-model="datePickerMenuOrderReferences[i]" :close-on-content-click="false" offset-y :nudge-bottom="10" transition="slide-y-transition">
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field v-model="$v.order.references.$each[i].date.$model" :error="$v.order.references.$each[i].date.$error" v-bind="attrs" v-on="on" readonly background-color="white" height="36" solo outlined flat dense hide-details>
                        <template v-slot:append>
                          <v-icon class="mr-3" small color="secondary">mdi-calendar</v-icon>
                        </template>
                      </v-text-field>
                    </template>
                    <v-date-picker v-model="$v.order.references.$each[i].date.$model" @input="datePickerMenuOrderReferences[i]=false" no-title :first-day-of-week="1" type="date" locale="es" width="270" color="primary">
                      <v-row class="py-2 px-6" align="center" justify="space-between">
                        <v-btn @click="() => { $v.order.references.$each[i].date.$model=null; datePickerMenuOrderReferences[i]=false }" outlined>Limpiar</v-btn>
                        <v-btn @click="() => { $v.order.references.$each[i].date.$model=today; datePickerMenuOrderReferences[i]=false }" color="primary">Hoy</v-btn>
                      </v-row>
                    </v-date-picker>
                  </v-menu>
                </v-col>
                <v-col cols="3" class="py-0">
                  <v-select v-model="$v.order.references.$each[i].document.$model" :error="$v.order.references.$each[i].document.$error" :items="referencesList" item-value="id" item-text="name" :menu-props="{ overflowY: true, transition: 'slide-y-transition' }" background-color="white" height="36" solo outlined flat dense hide-details />
                </v-col>
                <v-col cols="2" class="py-0">
                  <v-text-field v-model.trim="$v.order.references.$each[i].serial.$model" :error="$v.order.references.$each[i].serial.$error" maxlength="18" background-color="white" height="36" solo outlined flat dense hide-details />
                </v-col>
                <v-col cols="4" class="py-0">
                  <v-text-field v-model.trim="$v.order.references.$each[i].description.$model" :error="$v.order.references.$each[i].description.$error" maxlength="36" background-color="white" height="36" solo outlined flat dense hide-details />
                </v-col>
                <v-col cols="1" class="py-0">
                  <v-btn class="mt-1" @click="order.references.splice(i, 1)" min-width="20" max-width="20" min-height="28" max-height="28" text color="red" :ripple="false"><v-icon size="20">mdi-delete</v-icon></v-btn>
                </v-col>
              </v-row>
              <v-row class="px-1" no-gutters>
                <v-col cols="12" class="py-0">
                  <v-btn text color="primary" :ripple="false" @click="addOrderReference"><v-icon left>mdi-plus</v-icon>Agregar referencia</v-btn>
                </v-col>
              </v-row>
            </v-col>
          </v-row>
          <!-- end additional information -->
        </v-card-text>
        <v-divider />
        <v-card-actions class="pa-4">
          <template v-if="instance.id">
            <span class="body-2">Borrador guardado {{order.updated | dateFromNow}}</span>
            <v-btn class="ml-3" @click="deleteOrder" :disabled="loadingSave || loadingFinalize" text color="primary" :ripple="false"><v-icon small>mdi-delete</v-icon>Eliminar borrador</v-btn>
          </template>
          <v-spacer />
          <v-btn @click="updateOrder('order', true)" :disabled="!instance.id" :loading="loadingSave || loadingFinalize" outlined>Guardar y salir</v-btn>
          <v-btn @click="updateOrder('order'), finalizeOrder()" :disabled="!order.id" :loading="loadingSave || loadingFinalize" color="primary">Crear orden</v-btn>
        </v-card-actions>
      </v-card>
    </v-col>

    <!-- modal customer -->
    <v-dialog v-model="dialogCustomer" width="700" persistent no-click-animation>
      <v-card>
        <v-toolbar color="transparent" flat height="55">
          <v-toolbar-title class="text--secondary subtitle-1 font-weight-medium">Seleccionar un cliente</v-toolbar-title>
          <v-spacer />
          <v-toolbar-items>
            <v-row align="center" justify="center" class="pr-1">
              <v-btn icon retain-focus-on-click :ripple="false" small @click="dialogCustomer=false"><v-icon small>mdi-close</v-icon></v-btn>
            </v-row>
          </v-toolbar-items>
        </v-toolbar>
        <v-divider />
        <v-card-text class="pa-0 background">
          <v-row align="center" justify="center" no-gutters>
            <v-col cols="12" class="text-left">
              <v-col class="py-2">
                <v-text-field v-model="customerQuery" background-color="white" outlined required single-line dense placeholder="Escribe para buscar un cliente..." hide-details />
              </v-col>
              <v-divider/>
              <v-skeleton-loader v-if="$store.state.customers.retrieveLoader" transition="fade-transition" type="list-item" />
              <template v-else>
                <template v-if="customersList.length">
                  <v-simple-table>
                    <template v-slot:default>
                      <tbody>
                        <tr v-for="d in customersList" :key="d.id" @click="setCustomer(d)" style="cursor: pointer">
                          <td>
                            <span class="body-1 text--secondary font-weight-medium">{{d.name}}</span>
                          </td>
                        </tr>
                      </tbody>
                    </template>
                  </v-simple-table>
                </template>
                <v-col v-else class="text-center py-5">
                  <v-icon color="secondary" size="70">mdi-close-circle</v-icon>
                  <span class="d-block subtitle-1">No existen clientes</span>
                </v-col>
              </template>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
    </v-dialog>
    <!-- end modal customer -->
  </v-row>
</template>
<script>
import { mapState } from 'vuex'
import { required, maxLength, numeric } from 'vuelidate/lib/validators'
import GenericViewMixin from '@/mixins/GenericViewMixin'
import cloneDeep from 'lodash/cloneDeep'
import debounce from 'lodash/debounce'
import moment from 'moment'
const query = { page_size: 100 }
let prevRoute = null
export default {
  mixins: [
    GenericViewMixin
  ],
  inject: ['theme'],
  components: {
    VBoilerplate: {
      functional: true,
      render (h, { data, props, children }) {
        return h('v-skeleton-loader', {
          ...data,
          props: {
            boilerplate: true,
            elevation: 2,
            ...props
          }
        }, children)
      }
    }
  },
  data: () => ({
    activeCustomer: {},
    active: false,
    aggregations: {
      lines: [{
        subtotal: 0
      }],
      amount: 0,
      exempt: 0,
      subtotal: 0,
      taxes: 0,
      total: 0
    },
    customerQuery: '',
    datePickerMenuOrderDate: false,
    datePickerMenuOrderReferences: [false],
    dialogCustomer: false,
    isAutoSaving: false,
    loadingInitial: false,
    loadingSave: false,
    loadingFinalize: false,
    menu: false,
    menuFiscal: [false],
    menuInvoicing: false,
    menuInvoicingUntil: false,
    order: {
      customer: null,
      document: null,
      date: '',
      amount: null,
      exempt: null,
      tax: null,
      tax_percent: null,
      total: null,
      shipping_type: 1,
      address: '',
      country: '',
      state: '',
      carrier_name: '',
      carrier_id: '',
      licence_plate: '',
      lines: [{
        name: '',
        exempt: false,
        unit_label: '',
        amount: null,
        quantity: 1,
        tax: null,
        tax_percent: null
      }],
      references: []
    },
    orderClone: {},
    selectDocuments: [],
    shippingTypes: [
      { value: '1', label: 'Operación constituye venta' },
      { value: '2', label: 'Ventas por efectuar' },
      { value: '3', label: 'Consignaciones' },
      { value: '4', label: 'Entrega gratuita' },
      { value: '5', label: 'Traslados internos' },
      { value: '6', label: 'Otros traslados no venta' },
      { value: '7', label: 'Guía de devolución' },
      { value: '8', label: 'Traslado para exportación. (no venta)' },
      { value: '9', label: 'Venta para exportación' }
    ],
    statesList: [],
    upgradeable: false
  }),
  computed: {
    activeDocument () {
      return this.documents.find(d => d.id === this.order.document) || {}
    },
    activeCurrency () {
      return this.currencies.find(c => c.id === this.activeCustomer.currency) || {}
    },
    aggregationsSource () {
      return {
        lines: this.order.lines.map(line => {
          return {
            exempt: line.exempt,
            amount: line.amount,
            quantity: line.quantity
          }
        }),
        discount_scheme: this.order.discount_scheme,
        discount: this.order.discount
      }
    },
    linesWithAmountsError () {
      const lines = this.$v.order.lines
      return this.order.lines.filter((l, i) => lines.$each[i].amount.$error || lines.$each[i].quantity.$error)
    },
    updated () {
      if (this.order.updated) {
        return moment(this.order.updated).fromNow()
      }
      return null
    },
    ...mapState({
      customersList: state => state.customers.customersList,
      countriesList: state => state.generals.countriesList,
      documents: state => state.generals.documentsList,
      instance: state => state.orders.ordersDetail,
      referencesList: state => state.generals.referencesList
    })
  },
  beforeRouteEnter (to, from, next) {
    prevRoute = from.name
    next()
  },
  created () {
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/references',
      query: {
        page_size: 500
      }
    })
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/documents',
      query: {
        country__in: [this.account.country.id, 'US'],
        is_order: 'True'
      }
    })
    .then(() => {
      // generic documents
      const generics = this.documents.filter(d => d.country !== this.account.country.id)
      this.selectDocuments.push({ header: 'Genéricos' })
      this.selectDocuments = [...this.selectDocuments, ...generics]
      // local documents
      const sameCountry = this.documents.filter(d => d.country === this.account.country.id)
      if (sameCountry.length) {
        this.selectDocuments.push({ divider: true })
        this.selectDocuments.push({ header: this.account.country.name })
        this.selectDocuments = [...this.selectDocuments, ...sameCountry]
      }
    })
    this.$store.dispatch('generals/LIST', {
      resource: 'generals/countries',
      query: query
    })
    .then(() => {
      this.order.country = this.account.country.id
    })
    if (this.$route.name === 'OrderCreate') {
      this.$store.commit('orders/SET_DETAIL', {
        response: { data: {}, config: {} },
        resource: 'orders',
        loader: false
      })
      this.order.date = this.today
    } else {
      if (prevRoute !== 'OrderCreate') {
        this.loadingInitial = true
      }
      this.$store.dispatch('orders/RETRIEVE', {
        resource: 'orders',
        id: this.$route.params.id
      })
      .then((response) => {
        if (this.instance.status === 'draft') {
          const data = cloneDeep(response.data)
          // assign id in nested attributes
          this.activeCustomer = data.customer
          data.customer = data.customer.id
          data.document = data.document.id
          this.order = data
        } else {
          this.$router.push({ name: 'OrderRetrieve', params: { id: this.instance.id } })
        }
      })
      .finally(() => {
        this.loadingInitial = false
      })
    }
  },
  watch: {
    activeDocument (newly, oldy) {
      const setExemptLines = (val) => {
        this.order.lines.forEach((l, i) => {
          this.order.lines[i].exempt = val
        })
      }
      if (this.activeDocument.has_taxes && !oldy.has_taxes) {
        setExemptLines(false)
      } else if (!this.activeDocument.has_taxes && oldy.has_taxes) {
        setExemptLines(true)
      }
      this.setAggregations()
    },
    aggregationsSource: {
      handler () {
        this.setAggregations()
      },
      deep: true
    },
    customerQuery () {
      this.debounceMethod(this.getCustomers)
    },
    dialogCustomer () {
      if (this.dialogCustomer) {
        this.getCustomers()
      }
    },
    order: {
      handler: debounce(function () {
        this.orderClone = cloneDeep(this.order)
        if (this.$route.name === 'OrderUpdate') {
          this.updateOrder('orderClone')
        } else {
          this.createOrder()
        }
      }, 700),
      deep: true
    },
    'order.country': {
      handler: function () {
        const country = this.countriesList.find(c => c.id === this.order.country)
        this.statesList = country ? country.states : []
        this.order.state = ''
      },
      inmediate: true
    }
  },
  methods: {
    createOrder () {
      this.$v.orderClone.$touch()
      if (this.$v.orderClone.$invalid) {
        return false
      }
      const payload = cloneDeep(this.order)
      this.loadingSave = true
      this.$store.dispatch('orders/CREATE', {
        resource: 'orders',
        payload: payload
      })
      .then((response) => {
        this.order = cloneDeep(response.data)
        this.order.document = this.order.document.id
        this.$router.replace(`/orders/${this.order.id}/edit`)
      })
      .finally(() => {
        this.loadingSave = false
      })
    },
    updateOrder (validate = 'order', exit = false) {
      this.$v[validate].$touch()
      if (this.$v[validate].$invalid) {
        return false
      }
      const payload = cloneDeep(this.order)
      delete payload.amount
      delete payload.exempt
      delete payload.status
      delete payload.tax
      delete payload.tax_percent
      delete payload.total
      this.loadingSave = true
      this.$store.dispatch('orders/UPDATE', {
        resource: 'orders',
        id: this.order.id,
        payload: payload
      })
      .then(() => {
        if (exit) {
          this.$router.push({ name: 'OrderList' })
        }
      })
      .finally(() => {
        this.loadingSave = false
      })
    },
    finalizeOrder () {
      this.$v.order.$touch()
      if (this.$v.order.$invalid) {
        return false
      }
      this.$dialog.warning({
        title: 'Confirmar orden',
        text: `
          <span class="d-block mb-4">Al confirmar esta orden:</span>
          <span class="d-block pl-6">1. Validará con la agencia fiscal de ${this.account.country.name}</span>
          <span class="d-block my-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            text: 'Continuar',
            color: 'primary',
            handle: () => {
              this.isAutoSaving = false
              this.loadingFinalize = true
              this.$store.dispatch('orders/RETRIEVE', {
                resource: 'orders',
                detail: 'finalize',
                id: this.order.id
              })
              .then(() => {
                this.$router.push({ name: 'OrderRetrieve', params: { id: this.instance.id } })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
              .finally(() => {
                this.loadingFinalize = false
              })
            }
          }
        ]
      })
    },
    deleteOrder () {
      if (!this.order.status === 'draft') {
        return false
      }
      this.$dialog.warning({
        title: 'Eliminar orden',
        text: `
          <span class="d-block mb-4">¿Estás seguro de continuar?</span>
          <span class="d-block font-weight-medium">Esta acción no se puede deshacer</span>
        `,
        actions: [
          {
            color: 'red',
            text: 'Continuar',
            handle: () => {
              this.$store.dispatch('orders/DESTROY', {
                resource: 'orders',
                id: this.order.id
              })
              .then(() => {
                this.$dialog.message.info('La order ha sido eliminada')
                this.$router.push({ name: 'OrderList' })
              })
              .catch((error) => {
                this.$dialog.message.error(this.parseErrors(error.response.data))
              })
            }
          }
        ]
      })
    },
    getCustomers () {
      if ([1, 2].includes(this.customerQuery.length)) {
        return false
      }
      const query = {
        page_size: 10
      }
      if (this.customerQuery.length >= 3) {
        query.name__icontains = this.customerQuery.toLowerCase()
      }
      this.$store.dispatch('customers/LIST', {
        resource: 'customers',
        query: query
      })
    },
    setCustomer (customer) {
      this.activeCustomer = customer
      this.order.customer = customer.id
      this.customerQuery = ''
      this.dialogCustomer = false
    },
    addOrderLine () {
      this.order.lines.push({
        name: '',
        exempt: false,
        unit_label: '',
        amount: null,
        quantity: 1,
        tax: null,
        tax_percent: null
      })
    },
    setAggregations () {
      const round = (this.activeCurrency.format && this.activeCurrency.format.precision === 0)
      let exempt = 0
      let amount = 0
      this.order.lines.forEach((line, i) => {
        this.aggregations.lines[i] = {
          subtotal: this.formatNumber((line.amount || 0) * (line.quantity || 0), round)
        }
        if (line.discount) {
          if (line.discount_scheme === '%') {
            this.aggregations.lines[i].subtotal -= this.aggregations.lines[i].subtotal * line.discount / 100
          } else {
            this.aggregations.lines[i].discount = this.formatNumber(line.discount, round)
            this.aggregations.lines[i].subtotal -= this.aggregations.lines[i].discount
          }
        }
        if (line.exempt || !this.activeDocument.has_taxes) {
          exempt += this.formatNumber(this.aggregations.lines[i].subtotal, round)
        } else {
          amount += this.formatNumber(this.aggregations.lines[i].subtotal, round)
        }
      })
      this.aggregations.exempt = this.formatNumber(exempt, round)
      this.aggregations.amount = this.formatNumber(amount, round)
      this.aggregations.subtotal = exempt + amount
      // taxes
      if (this.activeDocument.has_taxes) {
        if (this.activeDocument.has_lines_total) {
          const initialAmount = this.aggregations.amount
          this.aggregations.amount = this.formatNumber(initialAmount / ((this.activeDocument.tax / 100) + 1), round)
          this.aggregations.taxes = this.formatNumber(initialAmount - this.aggregations.amount, round)
        } else {
          this.aggregations.taxes = this.formatNumber(this.aggregations.amount * (this.activeDocument.tax / 100), round)
        }
      } else {
        this.aggregations.taxes = 0
      }
      // total
      this.aggregations.total = this.formatNumber(this.aggregations.exempt + this.aggregations.amount + this.aggregations.taxes, round)
    },
    addOrderReference () {
      this.order.references.push({
        date: null,
        description: '',
        document: '',
        serial: ''
      })
    }
  },
  validations () {
    const order = {
      customer: {
        required
      },
      document: {
        required,
        currencyIsValid: function () {
          if (!this.order.customer) {
            return true
          }
          const currencies = this.activeDocument.currencies || []
          if (currencies.length) {
            return currencies.includes(this.activeCustomer.currency)
          }
          return false
        }
      },
      date: {
        required
      },
      shipping_type: {
        required
      },
      address: {
        maxLength: maxLength(70)
      },
      carrier_name: {
        maxLength: maxLength(30)
      },
      carrier_id: {
        maxLength: maxLength(10)
      },
      licence_plate: {
        maxLength: maxLength(7)
      },
      note: {
        maxLength: maxLength(100)
      },
      lines: {
        $each: {
          name: {
            required,
            maxLength: maxLength(128)
          },
          description: {
            maxLength: maxLength(512)
          },
          unit_label: {
            maxLength: maxLength(4)
          },
          quantity: {
            required,
            numeric
          },
          amount: {
            required,
            numeric
          }
        }
      },
      references: {
        $each: {
          date: {
            required
          },
          description: {
            maxLength: maxLength(64)
          },
          document: {
            required
          },
          serial: {
            required,
            maxLength: maxLength(36)
          }
        }
      }
    }
    return {
      order: order,
      orderClone: cloneDeep(order)
    }
  }
}
</script>